import { Priority } from '../enums';
import { PriorityIconStyle } from '../model';

export function getPriorityIconStyle(priority: number): PriorityIconStyle {
  switch (true) {
    case priority < 60:
      return {
        textValue: Priority.Low,
        color: '#648D18',
      };
    case priority >= 60 && priority < 90:
      return {
        textValue: Priority.Medium,
        color: '#F5A623',
      };
    case priority >= 90:
    default:
      return {
        textValue: Priority.High,
        color: '#AC1822',
      };
  }
}
